import { useUIContext } from "@/context/UIContext";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
  const { darkMode, setDarkMode } = useUIContext();

  return (
    <button
      className="hidden sm:flex items-center justify-center fixed bottom-8 right-8
                 px-2 py-1 gap-x-1 text-sm bg-white dark:bg-neutral-800 shadow-md
                 shadow-black/10 dark:shadow-black/30 text-neutral-600
                 dark:text-neutral-400 rounded-full cursor-pointer border
                 border-neutral-200 dark:border-neutral-700 hover:text-blue-500
                 dark:hover:text-yellow-400 focus-visible:outline-2 outline-offset-2"
      onClick={() => setDarkMode(!darkMode)}
    >
      {darkMode ? <Sun size={20} /> : <Moon size={20} />}
      {darkMode ? " Light mode" : " Dark mode"}
    </button>
  );
}
